import { render, staticRenderFns } from "./ForumStockChartLink.vue?vue&type=template&id=77cb2470&"
import script from "./ForumStockChartLink.vue?vue&type=script&lang=js&"
export * from "./ForumStockChartLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports